import {Box, BoxProps} from '@mui/material';
import {ReactNode} from 'react';
import {neutral, radius} from 'src/theme';

interface FilterBarProps extends Omit<BoxProps, 'children'> {
  children: ReactNode;
}

/**
 * Consistent filter bar container for list pages.
 *
 * Wraps filter controls (SearchInput, Select, DatePicker) in a styled row
 * with consistent background, padding, gap, and border radius.
 *
 * Usage:
 *   <FilterBar>
 *     <SearchInput ... />
 *     <Select ... />
 *     <Select ... />
 *   </FilterBar>
 */
export default function FilterBar({children, sx, ...props}: FilterBarProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        flexWrap: 'wrap',
        bgcolor: neutral[25],
        borderRadius: `${radius.lg}px`,
        border: `1px solid ${neutral[200]}`,
        px: 2,
        py: 1.5,
        ...sx,
      }}
      {...props}
    >
      {children}
    </Box>
  );
}
